import React, { FunctionComponent } from "react";

import { QAProps } from "@multiweb/types/react";
import { NumberFormatter, NumberFormatterProps } from "../NumberFormatter";
import { Text, TextProps } from "../Text";

export type NumberValueProps = Pick<NumberFormatterProps, "displayFormat" | "value" >
    & Pick<TextProps, "fontWeight" | "color" | "title" | "disabled" | "ellipsis">
    & QAProps;

/** Číselná hodnota formátovaná podle zadaného formátu */
export const NumberValue: FunctionComponent<NumberValueProps> = ({
    value,
    displayFormat,
    fontWeight,
    color,
    title,
    disabled = false,
    qa,
    ellipsis = true,
}) => (
    <NumberFormatter {...{ value, displayFormat }}>
        {(formattedValue) => (
            <Text
                value={formattedValue}
                {...{ title, fontWeight, color, disabled, qa, ellipsis }}
            />
        )}
    </NumberFormatter>
);
